import React, { useEffect } from "react";
import { useSearchParams, useNavigate } from "react-router-dom";
import toast from "react-hot-toast";

import { ACL_ROUTE, Role } from "../../utility/constant";
import { axiosInstance } from "../../utility/apiInstance";

const RedirectLogin: React.FC = () => {
    const [searchParams] = useSearchParams();
    const navigate = useNavigate();
    const token = searchParams.get("token");

    useEffect(() => {
        if (!token) {
            toast.error("Invalid or missing login token");
            // navigate("/auth/login"); // Optional: redirect to login if no token
            return;
        }

        autoLogin(token);
    }, [token]);

    const autoLogin = async (jwtToken: string) => {
        try {
            // 1. Fetch fresh user data using the token from URL
            const { data } = await axiosInstance.get(
                "/api/v1/customers-auth",
                {
                    headers: {
                        Authorization: `Bearer ${jwtToken}`,
                    },
                }
            );

            const customer = data?.data;

            if (!customer || !customer.role) {
                throw new Error("User data or role not found");
            }

            // 2. Persist to LocalStorage
            localStorage.setItem("token", jwtToken);
            localStorage.setItem("email", customer?.contactInfo?.email || "");

            // 3. Clear the URL state
            window.history.replaceState(null, "", "/");

            // 4. Determine destination based on the NEWLY fetched role
            // We use the direct response 'customer.role' to avoid stale context issues
            const userRole:Role = customer.role;
            const allowedRoutes = ACL_ROUTE[userRole];
            const targetPath = allowedRoutes?.[0];

          

            if (targetPath) {
                // Use { replace: true } so user can't go "Back" to this loading screen
                navigate(targetPath, { replace: true });
            } else {
                // toast.error("Access Denied: No routes assigned to your role.");
                navigate("/auth/login");
            }

        } catch (error: any) {
            const errorMessage = error.response?.data?.error || "Login link expired or invalid";
            toast.error(errorMessage);
            // navigate("/auth/login");
        }
    };

    return (
        <div
            style={{
                minHeight: "100vh",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                background: "linear-gradient(135deg, #0f2027, #203a43, #2c5364)",
                fontFamily: "'Segoe UI', Tahoma, Geneva, Verdana, sans-serif",
            }}
        >
            <div
                style={{
                    backgroundColor: "#ffffff",
                    padding: "50px 60px",
                    borderRadius: "16px",
                    boxShadow: "0 20px 40px rgba(0,0,0,0.25)",
                    textAlign: "center",
                    maxWidth: "420px",
                    width: "100%",
                }}
            >
                {/* Logo / Icon */}
                <div
                    style={{
                        width: "70px",
                        height: "70px",
                        margin: "0 auto 20px",
                        borderRadius: "50%",
                        backgroundColor: "#fab800",
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center",
                        fontSize: "32px",
                        fontWeight: "bold",
                        color: "#ffffff",
                        boxShadow: "0 8px 20px rgba(250, 184, 0, 0.5)",
                    }}
                >
                    🚚
                </div>

                {/* Title */}
                <h3
                    style={{
                        margin: "0 0 10px",
                        fontSize: "22px",
                        fontWeight: 600,
                        color: "#203a43",
                    }}
                >
                    Signing you in…
                </h3>

                {/* Subtitle */}
                <p
                    style={{
                        margin: "0 0 30px",
                        fontSize: "14px",
                        color: "#6b7280",
                    }}
                >
                    Please wait while we securely redirect you
                </p>

                {/* Progress Bar */}
                <div
                    style={{
                        width: "100%",
                        height: "6px",
                        backgroundColor: "#e5e7eb",
                        borderRadius: "4px",
                        overflow: "hidden",
                    }}
                >
                    <div
                        style={{
                            width: "60%",
                            height: "100%",
                            background: "linear-gradient(90deg, #fab800, #ffcc33, #fab800)",
                            animation: "loading 1.5s infinite",
                        }}
                    />
                </div>

                {/* Footer text */}
                <p
                    style={{
                        marginTop: "25px",
                        fontSize: "12px",
                        color: "#9ca3af",
                    }}
                >
                    CargoDash • Smart Shipment Tracking
                </p>
            </div>

            <style>
                {`
                @keyframes loading {
                    0% { transform: translateX(-100%); }
                    100% { transform: translateX(200%); }
                }
                `}
            </style>
        </div>
    );
};

export default RedirectLogin;